export default __webpack_public_path__ + "static/media/OrdLupa.c11ba82e.svg";